import React, { useState } from 'react';
import { Header } from './components/Header';
import { BrandPage } from './components/BrandPage';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
export function App() {
  const [selectedBrand, setSelectedBrand] = useState(null);
  // Mock brands data
  const brands = [{
    id: 1,
    name: 'Acme Inc'
  }, {
    id: 2,
    name: 'TechGiant'
  }, {
    id: 3,
    name: 'SecureWeb'
  }];
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-slate-50" data-id="element-1">
        <Header brands={brands} selectedBrand={selectedBrand} setSelectedBrand={setSelectedBrand} data-id="element-2" />
        <main className="flex-1 container mx-auto px-4 py-6" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Dashboard data-id="element-6" />} data-id="element-5" />
            <Route path="/brand/:brandId/*" element={<BrandPage data-id="element-8" />} data-id="element-7" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-10" />} data-id="element-9" />
          </Routes>
        </main>
      </div>
    </Router>;
}